<div class="modal-wrap">
    <div class="title">Recaptcha error</div>

    <div class="descr">Please verify the authenticity of your request.</div>

    <div class="recaptcha-wrap">
        <re-captcha id="recaptcha" name="recaptcha" #recaptcha="ngModel" (resolved)="resolveCaptcha()" [(ngModel)]="helper.token"></re-captcha>
    </div>
</div>